export default __webpack_public_path__ + "static/media/no_cards.73342ac5.png";